import React from 'react';
import { useAppTheme } from '../../context/ThemeContext';

interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  children: React.ReactNode;
}

interface FormGroupProps {
  children: React.ReactNode;
  className?: string;
}

interface FormLabelProps {
  children: React.ReactNode;
  htmlFor?: string;
  required?: boolean;
  className?: string;
}

interface FormErrorProps {
  children: React.ReactNode;
  className?: string;
}

interface FormHelperTextProps {
  children: React.ReactNode;
  className?: string;
}

const Form: React.FC<FormProps> = ({ children, onSubmit, className = '', ...props }) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <form onSubmit={handleSubmit} className={`space-y-4 ${className}`} {...props}>
      {children}
    </form>
  );
};

const FormGroup: React.FC<FormGroupProps> = ({ children, className = '' }) => {
  return (
    <div className={`space-y-2 ${className}`}>
      {children}
    </div>
  );
};

const FormLabel: React.FC<FormLabelProps> = ({ children, htmlFor, required, className = '' }) => {
  const { themeConfig } = useAppTheme();
  
  return (
    <label
      htmlFor={htmlFor}
      className={`block text-sm font-medium text-[${themeConfig.text}] ${className}`}
    >
      {children}
      {required && <span className="text-[${themeConfig.error}] ml-1">*</span>}
    </label>
  );
};

const FormError: React.FC<FormErrorProps> = ({ children, className = '' }) => {
  const { themeConfig } = useAppTheme();
  
  return (
    <p className={`text-sm text-[${themeConfig.error}] ${className}`}>
      {children}
    </p>
  );
};

const FormHelperText: React.FC<FormHelperTextProps> = ({ children, className = '' }) => {
  const { themeConfig } = useAppTheme();
  
  return (
    <p className={`text-sm text-[${themeConfig.text}] opacity-70 ${className}`}>
      {children}
    </p>
  );
};

export { Form, FormGroup, FormLabel, FormError, FormHelperText }; 